import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import './LootTable.css';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from "@mui/material";

function LootTable(props) {

    const players = props.players;
    const pieces = ['weapon', 'head', 'body', 'hands', 'legs', 'feet', 'ears', 'neck', 'wrists', 'fingerL']
    const sides = [['weapon', 'head', 'body', 'hands', 'legs', 'feet'], ['ears', 'neck', 'wrists', 'fingerL', 'fingerR']]

    function normalizeName(player) {
        if (player.name.length > 12)
            return `${player.name.substring(0, 9).toUpperCase()}...`;
        return player.name.toUpperCase();
    }

    function generateHeader() {

        return (
            <TableHead>
                <TableRow>
                    <TableCell ></TableCell>
                    {players.map((player) => <TableCell className="worthless" style={{ textAlign: 'center', backgroundColor: `${player.color}`, width: '120px', fontFamily: 'Noto Sans' }} key={`${player.playerID}name`}>
                        {normalizeName(player)}
                    </TableCell>)}
                </TableRow>
            </TableHead>
        )
    }

    function playerNeedGear(player, gearPiece) {
        if (gearPiece == 'fingerL' && (player.neededGear['fingerL'] == 'raid' || player.neededGear['fingerR'] == 'raid')) {
            if ((player.neededGear['fingerL'] == 'raid' && !player.acquiredGear['fingerL'] || player.neededGear['fingerR'] == 'raid' && !player.acquiredGear['fingerR']))
                return "Need"
            else if (player.neededGear['fingerL'] == 'raid' && player.acquiredGear['fingerL'])
                return <CheckIcon style={{ width: '15px', height: '15px', marginBottom: '-2px', color: '#3dff87' }} />
            else if (player.neededGear['fingerR'] == 'raid' && player.acquiredGear['fingerR'])
                return <CheckIcon style={{ width: '15px', height: '15px', marginBottom: '-2px', color: '#3dff87' }} />
        }
        else if (player.neededGear[gearPiece] == 'raid' && !player.acquiredGear[gearPiece])
            return "Need"
        else if (player.neededGear[gearPiece] == 'raid')
            return <CheckIcon style={{ width: '15px', height: '15px', marginBottom: '-2px', color: '#3dff87' }} />
        return ''
    }

    function missingAugments(player, augment) {
        if (augment == 'twine') {
            var twinesMissing = player.twinesNeeded - player.twinesAcquired
            if (player.twinesAcquired == 0 && twinesMissing != 0)
                return <text>{player.twinesAcquired} / {player.twinesNeeded}</text>
            else if (player.twinesAcquired > 0 && twinesMissing > 0)
                return <text style={{ color: '#ffc061' }}>{player.twinesAcquired} / {player.twinesNeeded}</text>
            else {
                return <text style={{ color: '#3dff87' }}>{player.twinesAcquired} / {player.twinesNeeded}</text>;
            }
        }
        if (augment == 'shine') {
            var shinesMissing = player.shinesNeeded - player.shinesAcquired
            if (player.shinesAcquired == 0 && shinesMissing != 0)
                return <text>{player.shinesAcquired} / {player.shinesNeeded}</text>
            else if (player.shinesAcquired > 0 && shinesMissing > 0)
                return <text style={{ color: '#ffc061' }}>{player.shinesAcquired} / {player.shinesNeeded}</text>
            else {
                return <text style={{ color: '#3dff87' }}>{player.shinesAcquired} / {player.shinesNeeded}</text>;
            }
        }
    }

    function normalizeGearName(gearPiece) {
        if (gearPiece == 'fingerL')
            gearPiece = 'RING'
        return gearPiece.toUpperCase();
    }

    function closeMenu() {
        props.closeMenu('table')
    }

    function generateBody() {
        return (
            <TableBody>
                {pieces.map((gearPiece) =>
                    <TableRow key={`${gearPiece}`}>
                        <TableCell className="cellCommon" key={`${gearPiece}`} style={{ textAlign: 'center', color: 'aliceblue', fontFamily: 'Noto Sans' }}>{normalizeGearName(gearPiece)}</TableCell>
                        {players.map((player) => <TableCell className="cellCommon" key={`${player.playerID}-${gearPiece}`} style={{ textAlign: 'center', color: 'aliceblue', fontFamily: 'Noto Sans' }} >
                            {playerNeedGear(player, gearPiece)}
                        </TableCell>)}
                    </TableRow>
                )}
                <TableRow>
                    <TableCell className="cellCommon" key='twine' style={{ textAlign: 'center', color: 'aliceblue', fontFamily: 'Noto Sans' }}>Left Aug.</TableCell>
                    {players.map((player) => <TableCell className="cellCommon" key={`${player.playerID}-twine`} style={{ textAlign: 'center', color: 'aliceblue', fontFamily: 'Noto Sans' }}>
                        {missingAugments(player, 'twine')}
                    </TableCell>)}
                </TableRow>
                <TableRow>
                    <TableCell className="cellCommon" key='shine' style={{ textAlign: 'center', color: 'aliceblue', fontFamily: 'Noto Sans' }}>Right Aug.</TableCell>
                    {players.map((player) => <TableCell className="cellCommon" key={`${player.playerID}-shine`} style={{ textAlign: 'center', color: 'aliceblue', fontFamily: 'Noto Sans' }}>
                        {missingAugments(player, 'shine')}
                    </TableCell>)}
                </TableRow>
            </TableBody>
        )
    }

    return (
        <div className='outerdiv' style={{ marginTop: '50px' }}>
            <div className='innerdivborder'>
                <div className='innerdiv' >
                    <div><Button className='close-btn' variant="contained" onClick={closeMenu}><CloseIcon style={{ color: '#fad99a' }} /></Button> </div>
                    <div style={{ fontSize: '36px', fontFamily: 'Noto Sans' }}>Loot Table</div>
                    <TableContainer className='table' style={{ marginTop: '25px', paddingTop: 0 }}>
                        <Table sx={{ minWidth: 400, width: 1400 }} size="small" >
                            {generateHeader()}
                            {generateBody()}
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </div>
    );
}

export default LootTable;